<!--员工帐号管理-->
<template>
  <Page class="queryView">
    <template v-slot:contentTop>
      <div class="queryView-conditions with-btn-end">
        <a-form class="flex-form " layout="inline" :form="form" :colon="false">
          <div class="grid grid-cols-2 2xl:grid-cols-3">
            <a-form-item label="员工姓名">
              <a-input v-decorator="['userName']" placeholder="请输入员工姓名" autocomplete="off"></a-input>
            </a-form-item>

            <a-form-item label="员工状态">
              <a-select
                class="form-control"
                :options="typesMap.isDisable"
                v-decorator="['isDisable']"
                allowClear
                placeholder="请选择"
              ></a-select>
            </a-form-item>
          </div>
        </a-form>

        <div class="condition-btns">
          <a-button class="app-btn" type="default" @click="resetAndQuery$qv">重置搜索</a-button>
          <a-button class="app-btn" type="primary" @click="doQuery(1)">立即搜索</a-button>
        </div>
      </div>
    </template>
    <div>
      <div class="pageContent-title">员工帐号列表</div>
      <div class="queryView-actions">
        <a-button class="app-btn" @click="addEmployee">
          <app-icon type="icon-tianjia"></app-icon>
          新建员工
        </a-button>
      </div>
      <div class="queryView-main">
        <!-- :scroll="{ x: 1400 }" -->
        <a-table
          class="mt-5"
          rowKey="userId"
          bordered
          :loading="tableLoading"
          :scroll="{ x: 1400 }"
          :columns="tableColumns"
          :dataSource="dataSource"
          @change="handleTableChange$qv"
          :pagination="{
            current: pageNumber,
            pageSize: pageSize,
            total: countTotal,
            showSizeChanger: true,
            showQuickJumper: true,
          }"
        ></a-table>
      </div>
    </div>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import { queryViewMixin, toolMixin } from '@/utils/mixin'
import PictureCardUpload from '@/components/pictureCardUpload/PictureCardUpload.vue'
import VueQrcode from '@chenfengyuan/vue-qrcode'
export default {
  mixins: [queryViewMixin, toolMixin],
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '5%',
        align: 'center',
        customRender: (text, row, index) => {
          return <span> {this.pageSize * (this.pageNumber - 1) + (index + 1)} </span>
        },
      },
      {
        title: '员工姓名',
        width: '15%',
        align: 'center',
        dataIndex: 'userName',
      },
      {
        title: '登录手机',
        width: '15%',
        align: 'center',
        dataIndex: 'phoneNumber',
      },
      {
        title: '角色权限',
        width: '15%',
        align: 'center',
        dataIndex: 'roleName',
      },
      {
        title: '状态',
        width: '15%',
        align: 'center',
        dataIndex: 'isDisable',
        customRender: (text, row) => {
          return <div>{this.translateType$t(text, 'isDisable')}</div>
        },
      },

      {
        title: '操作',
        width: '20%',
        align: 'center',
        customRender: (text, row) => {
          return (
            <div class="flex gap-5 justify-center text-primary-500">
              <app-icon
                type="icon-bianji"
                class="cursor-pointer"
                onClick={() => {
                  this.editRow(row)
                }}
                title="编辑 "
              ></app-icon>

              <app-icon
                type={row.isDisable ? 'icon-qiyong' : 'icon-jinyong'}
                class="cursor-pointer"
                onClick={() => {
                  this.changeDisable(row)
                }}
                title={row.isDisable ? '启用' : '禁用'}
              ></app-icon>
              <app-icon
                type="icon-shanchu"
                class="cursor-pointer"
                onClick={() => {
                  this.deleteRow(row)
                }}
                title="删除"
              ></app-icon>
            </div>
          )
        },
      },
    ]
    return {
      form: this.$form.createForm(this),
      pageNumber: 1,
      pageSize: 10,
      countTotal: 0,
      tableLoading: false,
      tableColumns: tableColumns,
      dataSource: [],
    }
  },
  components: {
    Page,
    PictureCardUpload,
    VueQrcode,
  },
  computed: {
    typesMap() {
      return {
        isDisable: [
          { value: 1, label: '未启用' },
          { value: 0, label: '启用中' },
        ],
      }
    },
  },
  methods: {
    async doQuery(_pageNumber = this.pageNumber, _pageSize = this.pageSize) {
      this.tableLoading = true
      try {
        const { userName, isDisable } = this.form.getFieldsValue()
        const res = await this.$axios.get('/user/admin/user/queryStaffList', {
          params: {
            page: _pageNumber,
            limit: _pageSize,
            userName: userName,
            isDisable: isDisable,
          },
        })
        this.countTotal = Number(res.count)
        this.pageSize = _pageSize
        this.pageNumber = _pageNumber
        this.dataSource = res.data
      } catch (e) {
        console.log(e)
      }
      this.tableLoading = false
    },
    editRow(row) {
      this.$router.push({
        path: '/m/scopeMain/empAccountManage/addEmployee',
        query: {
          userId: row.userId,
        },
      })
    },
    async deleteRow(row) {
      await this.$modal({
        title: '确认删除？',
        content: <div class="h-28 flex items-center justify-center text-red-400">你确认要删除该员工？</div>,
      })
      await this.$axios.delete('/user/admin/user/deleteByUserId?userId=' + row.userId)
      this.$message.success('操作成功')
      this.doQuery()
    },
    async changeDisable(row) {
      const title = row.isDisable ? '启用员工账号' : '禁用员工账号'
      const content = (
        <div class="h-28 flex items-center justify-center text-red-400">
          {row.isDisable ? '你确定要启用员工帐号？' : '你确认要禁用该员工帐号？'}
        </div>
      )
      await this.$modal({
        title,
        content,
      })
      await this.$axios.post('/user/admin/user/isDisable', {
        userId: row.userId,
        isDisable: row.isDisable ? 0 : 1,
      })
      this.$message.success('操作成功')
      this.doQuery()
    },
    addEmployee() {
      this.$router.push({
        path: '/m/scopeMain/empAccountManage/addEmployee',
      })
    },
  },
  mounted() {
    this.doQuery()
  },
}
</script>

<style lang="less" scoped>
.qrcode-container {
  width: 148px;
  height: 148px;
  background: #ddd;
}
.botton-s {
  border: 2px solid #dfdfdf;
  padding: 5px 10px;
  cursor: pointer;
}
</style>
